/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import '../styles/solicitudes.css';

// Components.
import { 
  Grid, 
  TextField, 
  Typography, 
  Button,  
  Tooltip,
  Autocomplete,
  Select,
  MenuItem,
  Box,
  InputLabel,
  FormControl,
  useMediaQuery,
  Card,
  CardContent,
  CircularProgress
} from '@mui/material';

import Heading from '../components/heading/Heading';
import Formatter from '../scripts/formatters';
import Item from '../components/custom/Item';
import CustomNoRowsOlverlay from '../components/custom/CustomNoRowsOlverlay';
import msgAlerta from '../scripts/alert';
import msgNotificacion from '../scripts/notification';
import SolicitudesDataGrid from '../components/styledDataGrid/SolicitudesDataGrid';
import FormVacacionesPdf from '../components/reactPDF/FormVacacionesPdf';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { PAGE_SIZE, NAME_PROJECT } from '../redux/constants/index';

// Iconos
import DoneIcon from '@mui/icons-material/Done';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import BlockIcon from '@mui/icons-material/Block';
import PrintIcon from '@mui/icons-material/Print';

// Services
import EmpleadoService from '../services/empleadoService';

export default function Solicitudes() {
  const dispatch = useDispatch()
  const userLogin = JSON.parse(localStorage.getItem('user'))
  const isMobile = useMediaQuery('(max-width: 740px)')
  let hiddeButtonsMobile = [2,3,4,5]
  
  // Si CodigoRol es 2, eliminamos "Aprobada"
  if (userLogin.CodigoRol === 2) {
    hiddeButtonsMobile = hiddeButtonsMobile.filter(button => button !== 2);
  }

  // States
  const [dataSolicitudes, setDataSolicitudes] = useState([])
  const [dataSolicitudSelected, setDataSolicitudSelected] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectionModel, setSelectionModel] = useState()
  const [codigoSolicitud, setCodigoSolicitud] = useState(null)
  const [dataEmpleados, setDataEmpleados] = useState([])
  const [dataTipo, setDataTipo] = useState([])
  const [dataEstados, setDataEstados] = useState([])    
  const [empleadoSelected, setEmpleadoSelected] = useState(null)
  const [valueFechas, setValueFechas] = useState({ fechaIni: '', fechaFin: '' })
  const [valueSelect, setValueSelect] = useState({ tipoSelected: '', estadoSelected: '' })

  // Print PDF
  const [printPdf, setPrintPdf] = useState(false)

  // Columns
  const columns = [
    {
      field: 'IdSolicitud',
      headerName: 'No.',
      align: 'center',
      headerAlign: 'center',
      width: 60,
    },
    {
      field: 'NoAccion',
      headerName: 'No. Accion',
      align: 'center',
      headerAlign: 'center',
      width: 90,      
    },
    {
      field: 'CodigoEmpleado',
      headerName: 'Código',
      align: 'center',
      headerAlign: 'center',
      width: 90,      
    },
    {
      field: 'NombreEmpleado',
      headerName: 'Nombre Empleado',
      minWidth: 220,
      flex: 1,
    },
    {
      field: 'FechaReg',
      headerName: 'Fecha Solic.',
      align: 'center',
      headerAlign: 'center',
      width: 140,      
      valueFormatter: ( value ) => Formatter.dateTimeFormatter(value)
    },
    {
      field: 'FechaInicio',
      headerName: 'Fecha Inicial',
      align: 'center',
      headerAlign: 'center',
      width: 140,
      valueFormatter: ( value ) => Formatter.dateTimeFormatter(value)
    },
    {
      field: 'FechaFinal',
      headerName: 'Fecha Final',
      align: 'center',
      headerAlign: 'center',
      width: 140,
      valueFormatter: ( value ) => Formatter.dateTimeFormatter(value)
    },
    {
      field: 'CantDias',
      headerName: 'Días',
      align: 'center',
      headerAlign: 'center',
      width: 60,
    },
    {
      field: 'CantHoras',
      headerName: 'Horas',
      align: 'center',
      headerAlign: 'center',
      width: 60,
    },
    {
      field: 'TipoSolicitud',
      headerName: 'Tipo',
      align: 'center',
      headerAlign: 'center',
      minWidth: 120,
      flex: 1,
    },
    {
      field: 'TipoVacacion',
      headerName: 'Solicitud',
      align: 'center',
      headerAlign: 'center',
      minWidth: 180,
      flex: 1,
    },
    {
      field: 'Estado',
      headerName: 'Estado',
      align: 'center',
      headerAlign: 'center',
      minWidth: 150,
      renderCell: (props) => {
        return (
          <div className={`MuiDataGrid-overlayWrapperInner MuiDataGrid-cellContent ${props.row.CssBg} rounded-4`}>
            <i className={`${props.row.CssIcon} mx-1 py-1`}></i>
            <Typography style={{ fontSize: 13 }} className='me-1'>{props.value}</Typography>
          </div>
        )
      }
    },
    {
      field: 'Motivo',
      headerName: 'Motivo del Permiso',
      minWidth: 400,      
      flex: 1,
    },
  ]
  
  // Functions
  function alertAllowSolicitud(idSolicitud) {
    try {
      
      // if (!codigoSolicitud) {
      //   if (idSolicitud)
      //     setCodigoSolicitud(idSolicitud)
      //   else {
      //     msgNotificacion('No ha seleccionado ninguna solicitud', 'warning')
      //     return
      //   }
      // }
      
      // Si no se pasa el idSolicitud, se toma el de la selección del DataGrid.
      const solicitud = idSolicitud ?? codigoSolicitud
      setCodigoSolicitud(solicitud)
      
      // Si es RHH se graba la vacación, sino es aprobada por el Jefe.
      const estado = userLogin.CodigoRol === 2 ? 5 : 2
      
      msgAlerta('Aprobar solicitud de vacación y/o permiso', `¿Seguro que desea aprobar la solicitud #${solicitud}?`, 'question', () => actualizarEstado(estado, solicitud))
    } catch (error) {
      console.error(error)
    }
  }

  function alertRejectSolicitud(idSolicitud) {
    try {
      // if (!codigoSolicitud) {
      //   if (idSolicitud)
      //     setCodigoSolicitud(idSolicitud)
      //   else {
      //     msgNotificacion('No ha seleccionado ninguna solicitud', 'warning')
      //     return
      //   }
      // }

      // Si no se pasa el idSolicitud, se toma el de la selección del DataGrid.
      const solicitud = idSolicitud ?? codigoSolicitud
      setCodigoSolicitud(solicitud)
      
      msgAlerta('Rechazar solicitud de vacación y/o permiso', `¿Seguro que desea rechazar la solicitud #${solicitud}?`, 'question', () => actualizarEstado(3, solicitud))
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeFechas = (event) => {
    try {
      setValueFechas({
        ...valueFechas,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  const actualizarEstado = async (estado, solicitud) => {
    try {
      const data = {
        solicitud: solicitud,
        estado: estado,
        usuarioAprob: userLogin.CodigoUsuario
      }                  

      if (!data.solicitud) {
        msgNotificacion('No ha sido seleccionada la solicitud que desea actualizar', 'warning')
        return
      }

      dispatch(showProgress(true))

      EmpleadoService.actualizarEstadoSolicitud(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            dispatch(showProgress(false))
            return
          }

          setTimeout(() => {
            if (response.Codigo === 1) {
              msgAlerta('Éxito!', response.Mensaje, 'success')
              
              refreshSolicitudes()
            } else {
              msgAlerta('Alerta!', response.Mensaje, 'warning')
            }

            dispatch(showProgress(false))
          }, 500);
        })
        .catch((error) => {
          dispatch(showProgress(false))
          msgNotificacion(error, 'error')
        })
    } catch (error) {
      console.error(error)
    }
  }
  
  const getSolicitudes = async (data) => {
    try {
      setLoading(true)

      EmpleadoService.getSolicitudes(data)
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            return
          }

          setTimeout(() => {
            if (response.Codigo === 1) {
              const dataResponse = response?.Data
              
              setDataSolicitudes(dataResponse)

              if (!valueFechas.fechaIni || !valueFechas.fechaFin) {
                setFilteredData(dataResponse)
              } else {
                filtrarSolicitudes(valueFechas.fechaIni, valueFechas.fechaFin) 
              }
            } else {
              setDataSolicitudes([])
              setFilteredData([])
              msgNotificacion(response.Mensaje, 'info')
            }

            setLoading(false)
          }, 500);
      })
      .catch((error) => {
        dispatch(showProgress(false));
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }

  const filtrarSolicitudes = (fechaI, fechaF) => {
    try {      
      const fechaIni = new Date(fechaI)
      const fechaFin = new Date(fechaF)
      
      const filteredData = dataSolicitudes.filter((item) => {
        const itemDate = formatearFecha(item.FechaReg)      
        const fecha = new Date(itemDate)
        
        return fecha >= fechaIni && fecha <= fechaFin
      })    
        
      setFilteredData(filteredData)      
    } catch (error) {
      console.error(error)
    }
  }

  const refreshSolicitudes = async () => {
    try {
      const dataRequest = {
        codEmpleado: userLogin.CodigoEmpleado
      }

      getSolicitudes(dataRequest)
      
      //
      setValueSelect({ ...valueSelect, tipoSelected: '', estadoSelected: '' })
      setEmpleadoSelected(null)
    } catch (error) {
      console.error(error)
    }
  }

  const formatearFecha = (date) => {
    try {
      if (!date) {
        return
      }
    
      let dateAsString = date.toString().substring(0, 10)
      let dateParts = dateAsString.split("-")
      let day = dateParts[2]
      let month = dateParts[1]
      let year = dateParts[0]
    
      return `${year}-${month}-${day}`;      
    } catch (error) {
      console.error(error)      
    }
  }

  const getDatosEmpleadosCbo = async () => {
    try {      
      EmpleadoService.getDatosCboSolicitud()
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }
  
          if (response.Codigo === 1) {
            const data = response.Data

            setDataEmpleados(data?.Empleados)
            setDataTipo(data?.TipoSolicitud)
            setDataEstados(data?.Estados)
          } else {
            setDataEmpleados([])
            msgNotificacion(response.Mensaje, 'warning')
          }
        })
        .catch((error) => {
          msgNotificacion(error, 'error')
          dispatch(showProgress(false))
        })
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeEmpleado = (event, values) => {
    try {
      setEmpleadoSelected(values)
      
      if (!values) {
        setLoading(true)
        
        setTimeout(() => {
          setFilteredData(dataSolicitudes)
          setLoading(false)          
        }, 500);

        return
      }

      // 
      setLoading(true)
      
      const codEmpleado = values.id
      setTimeout(() => {
        let filteredEmpleado = dataSolicitudes

        // filtro por empleado
        if (codEmpleado !== 'EM00000') {
          filteredEmpleado = dataSolicitudes.filter((item) => item.CodigoEmpleado === codEmpleado)
        }

        // Filtro por estado
        if (valueSelect.estadoSelected) {
          const estado = parseInt(valueSelect.estadoSelected)
          filteredEmpleado = filteredEmpleado.filter((x) => x.IdEstado === estado)
        }

        // Filtro por tipo solicitud
        if (valueSelect.tipoSelected) {
          const tipo = valueSelect.tipoSelected === '1' ? 'Vacaciones' : 'Permiso'
          filteredEmpleado = filteredEmpleado.filter(item => item.TipoSolicitud === tipo)
        }
        
        setFilteredData(filteredEmpleado)
        setLoading(false)
      }, 500)
    } catch (error) {
      console.error(error)
    }
  }
  
  const handleSelectChange = (event) => {
    try {
      setValueSelect({
        ...valueSelect,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  const handlePrintRequest = (idSolicitud) => {
    try {
      // Si no se pasa el idSolicitud, se toma el de la selección del DataGrid.
      const solicitud = idSolicitud ?? codigoSolicitud
      setCodigoSolicitud(solicitud)

      if (!solicitud) {
        msgNotificacion('No ha seleccionado ninguna solicitud', 'warning')
        return
      }
  
      const dataFiltered = dataSolicitudes.filter(item => item.IdSolicitud === parseInt(solicitud))
      setDataSolicitudSelected(dataFiltered)      
              
      setPrintPdf(true)
    } catch (error) {
      console.error(error)
    }
  }

  let initPage = false

  useEffect(() => {
    document.title = `Solicitudes de Permiso y/o Vacaciones de Empleados - ${NAME_PROJECT}`;    

    try {
      dispatch(showProgress(true))
                  
      setTimeout(() => {
        if (!initPage) {          
          initPage = true;
          
          const data = {
            codEmpleado: userLogin.CodigoEmpleado
          }

          getSolicitudes(data)          
          getDatosEmpleadosCbo()
        }
        
        dispatch(showProgress(false))
      }, 1000)
    } catch (error) {
      console.error(error)
    }
  }, [])

  useEffect(() => {
    try {
      if (valueSelect.tipoSelected) {
        const tipo = valueSelect.tipoSelected === '1' ? 'VACACIONES' : 'PERMISO'     
        const filtered = dataSolicitudes.filter(item => item.TipoSolicitud === tipo)
        
        let filterData = []
        
        // Filtro por estado
        if (valueSelect.estadoSelected) {
          const estado = parseInt(valueSelect.estadoSelected)
          filterData = filtered.filter((x) => x.IdEstado === estado)
        } else {
          filterData = filtered
        }

        // Filtro por empleado
        if (empleadoSelected) {
          const empleado = empleadoSelected.id
          filterData = filterData.filter((x) => x.CodigoEmpleado === empleado)
        }

        setLoading(true)
        setTimeout(() => {
          setLoading(false)
          setFilteredData(filterData)
        }, 500)
      }
    } catch (error) {
      console.error(error)
    }
  }, [valueSelect.tipoSelected])

  useEffect(() => {
    try {
      if (valueSelect.estadoSelected) {
        const estado = parseInt(valueSelect.estadoSelected)
        const filtered = dataSolicitudes.filter(item => item.IdEstado === estado)
                
        let filterData = []

        // filtro por tipo.
        if (valueSelect.tipoSelected) {
          const tipo = valueSelect.tipoSelected === '1' ? 'VACACIONES' : 'PERMISO'
          filterData = filtered.filter(item => item.TipoSolicitud === tipo)
        } else {
          filterData = filtered
        }

         // Filtro por empleado
         if (empleadoSelected) {
          const empleado = empleadoSelected.id
          filterData = filterData.filter((x) => x.CodigoEmpleado === empleado)
        }
        
        setLoading(true)
        setTimeout(() => {
          setLoading(false)
          setFilteredData(filterData)
        }, 500)
      }
    } catch (error) {
      console.error(error)
    }
  }, [valueSelect.estadoSelected])

  return <div className='App-content'>

    <Heading className='mt-0 w-100 heading heading-title'>
      <div className='heading-text'>
        <i className='bx bxs-calendar-exclamation me-2'></i>
        <span>Solicitudes de Vacaciones y/o permisos</span>
      </div>

      <div className='d-flex dv-filt-fechas-solic'>
        <div className='d-flex w-100 justify-content-evenly dv-buttons-refresh'>
          <Tooltip title='Seleccionar una solicitud para imprimir'>
            <Button
              variant='contained'
              className='text-transform-none mx-1'
              color='info'
              onClick={() => handlePrintRequest(null)}
              size='small'
              startIcon={<PrintIcon />}
            >
              Imprimir Solicitud
            </Button>
          </Tooltip>

          <Tooltip title='Refrescar datos'>
            <Button
              variant='outlined'
              className='text-transform-none mx-1'
              color='info'
              startIcon={<RestartAltIcon />}
              onClick={() => refreshSolicitudes()}
              size='small'
            >
              Refrescar
            </Button>
          </Tooltip>
        </div>

        <div className='d-flex filt-fechas-solic'>
          <TextField
            id='txtFechaInicio'
            name='fechaIni'
            type='date'
            label='Fecha inicial'
            size='small'
            fullWidth
            value={valueFechas.fechaIni}
            onChange={handleChangeFechas}
            className='mx-1'
            InputLabelProps={{
              shrink: true,
              className: 'LabelMui'
            }}
          />

          <TextField
            id='txtFechaFinal'
            name='fechaFin'
            type='date'
            label='Fecha final'
            size='small'
            fullWidth
            value={valueFechas.fechaFin}
            onChange={handleChangeFechas}
            className='mx-1'
            InputLabelProps={{
              shrink: true,
              className: 'LabelMui'
            }}
          />
        </div>
      </div>
    </Heading>

    <FormVacacionesPdf
      data={dataSolicitudSelected}
      print={printPdf}
      setPrint={setPrintPdf}
    />

    <Grid container spacing={1}>
      <Heading className='heading-buttons heading-subtitle-solic'>
        <Autocomplete
          id="cboEmpleados"
          getOptionLabel={option => (option.id + ' - ' + option.label)}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          options={dataEmpleados}
          fullWidth
          className='me-2 text-transform-none'
          value={empleadoSelected || null}
          onChange={handleChangeEmpleado}
          renderInput={(params) => <TextField {...params} label="Listado de Empleados" className='text-transform-none' />}
        />

        <Box sx={{ marginRight: 1, marginTop: 1, display: 'flex', minWidth: 400 }} className='box-select'>
          <FormControl fullWidth size='small' className='me-2'>
            <InputLabel id='TipoLabel' className='text-transform-none'>Tipo de Solicitud</InputLabel>
            <Select
              id='cboTipo'
              name='tipoSelected'
              label='Tipo de Solicitud'
              value={valueSelect.tipoSelected}
              onChange={handleSelectChange}
              fullWidth
              size='small'
              className='text-start'
              displayEmpty
            >
              {
                dataTipo?.map((item) => { 
                  return (
                    <MenuItem key={item.Id} value={item.Id.toString()}>{item.Nombre}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>

          <FormControl fullWidth size='small'>
            <InputLabel id='EstadoLabel' className='text-transform-none'>Estado</InputLabel>
            <Select
              id='cboEstado'
              name='estadoSelected'
              label='Estado'
              value={valueSelect.estadoSelected}
              onChange={handleSelectChange}
              fullWidth
              size='small'
              className='text-start'
              displayEmpty
            >
              {
                dataEstados?.map((item) => {
                  return (
                    <MenuItem key={item.Id} value={item.Id.toString()}>{item.Nombre}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
        </Box>

        <div className='d-flex w-100 justify-content-end dv-buttons-solic'>
          <Button
            variant='contained'
            className='text-transform-none float-right me-2'
            color='error'
            startIcon={<BlockIcon />}
            size='small'
            onClick={() => alertRejectSolicitud(null)}
          >
            Rechazar
          </Button>

          <Button
            variant='contained'
            className='text-transform-none float-right mx-1'
            color='success'
            onClick={() => alertAllowSolicitud(null)}
            size='small'
            startIcon={<DoneIcon />}
          >
            {userLogin.CodigoRol === 2 ? 'Aplicar' : 'Aprobar'}
          </Button>
        </div>
      </Heading>
    </Grid>

    <>
      {isMobile ? (
        // Vista móvil: Lista de tarjetas
        loading ?
          <Grid container spacing={1} paddingX={1} height='100%' textAlign='center' alignItems='center'>
            <Grid item xs={12}>
              <CircularProgress color='inherit' />
            </Grid>
          </Grid>
        :        
        <Grid container spacing={1} paddingX={1} paddingTop={1}>
          {filteredData.map((row) => (
            <Grid item xs={12} key={row.IdSolicitud}>
              <Card>
                <CardContent>
                  <Typography variant="h6"><strong>Solicitud #{row.IdSolicitud}</strong></Typography>
                  <Typography variant="body2">
                    <strong>Empleado: </strong><span className='mx-1'>{row.CodigoEmpleado} - {row.NombreEmpleado}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha Solicitud:</strong><span className='mx-1'>{Formatter.dateTimeFormatter(row.FechaReg)}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha Inicio:</strong><span className='mx-1'>{Formatter.dateTimeFormatter(row.FechaInicio)}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha Final:</strong><span className='mx-1'>{Formatter.dateTimeFormatter(row.FechaFinal)}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Días:</strong><span className='mx-1 fw-bolder text-blue'>{row.CantDias}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Horas:</strong><span className='mx-1 fw-bolder text-blue'>{row.CantHoras}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Tipo:</strong><span className={`mx-1 ${row.TipoSolicitud === 'VACACIONES' ? 'text-danger fw-bolder': 'text-blue fw-bolder'}`}>{row.TipoSolicitud}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Solicitud:</strong><span className='mx-1'>{row.TipoVacacion}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Motivo:</strong><span className='mx-1'>{row.Motivo}</span>
                  </Typography>
                  <Typography variant="body2" className={row.CssBg} display='flex' alignItems='center' borderRadius={4}>
                    <i className={`${row.CssIcon} mx-1`}></i>
                    <strong>Estado:</strong><span className='mx-1'>{row.Estado}</span>
                  </Typography>
                  <div style={{ marginTop: '10px' }} >
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      onClick={() => alertAllowSolicitud(row.IdSolicitud)}
                      className={`text-transform-none me-2 ${hiddeButtonsMobile.includes(row.IdEstado) ? 'd-none' : ''}`}
                    >
                      {userLogin.CodigoRol === 2 ? 'Aplicar' : 'Aprobar'}
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => alertRejectSolicitud(row.IdSolicitud)}
                      className={`text-transform-none me-2 ${hiddeButtonsMobile.includes(row.IdEstado) ? 'd-none' : ''}`}
                    >
                      Rechazar
                    </Button>
                    <Button
                      variant="contained"
                      color="info"
                      size="small"
                      onClick={() => handlePrintRequest(row.IdSolicitud)}
                      className='text-transform-none'
                    >
                      Imprimir
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={1} paddingX={1} paddingTop={1}>
          <Grid item xs={12} md={12}>
            <Item className='MuiPaper-root-dataGrid-solicitudes'>
              <SolicitudesDataGrid
                rows={filteredData}
                columns={columns}
                getRowId={(row) => row?.IdSolicitud}
                pageSize={PAGE_SIZE}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                loading={loading}
                localeText={Formatter.localizedTextsMapColumns}
                getRowClassName={(params) => `super-app-theme--${params.row?.Estado}`}
                onRowSelectionModelChange={(selection) => {
                  if (selection.length > 1) {
                    const selectionSet = new Set(selectionModel)
                    const result = selection.filter((s) => !selectionSet.has(s))

                    setSelectionModel(result)
                    setCodigoSolicitud(result[0])
                  } else {
                    setSelectionModel(selection)
                    setCodigoSolicitud(selection[0])
                  }
                }}
                // Ocultar la casilla de check all.
                sx={{
                  "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                    display: "none"
                  }
                }}
                rowSelectionModel={selectionModel}
                showCellVerticalBorder
                showColumnVerticalBorder
                checkboxSelection
                density='compact'
                slots={{
                  noRowsOverlay: CustomNoRowsOlverlay
                }}
              />
            </Item>
          </Grid>
        </Grid>
      )
      }
    </>

  </div>
}